import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';

/**
 * Impostazioni dell'utente. Al momento contiene solo la pulizia dei dati locali
 * (cookie e storage del browser) con logout, la stessa presente in /tos.
 * Raggiungibile da tutti gli utenti loggati (nessun PermissionGuard): il link è
 * nel menu utente della navbar privata.
 */
@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css'
})
export class SettingsComponent {
  /** True mentre è in corso la pulizia dei dati locali (disabilita il pulsante) */
  isClearing = false;

  constructor(
    private authService: AuthService,
    private translate: TranslateService
  ) {}

  /** True se l'utente ha una sessione attiva: la pulizia comporta anche il logout */
  get isLoggedIn(): boolean {
    return this.authService.hasLongLivedToken();
  }

  /**
   * Pulisce cookie e storage dell'applicativo. Se l'utente è autenticato
   * esegue anche il logout. Chiede sempre conferma.
   */
  async clearLocalData(): Promise<void> {
    if (this.isClearing) {
      return;
    }

    const confirmKey = this.isLoggedIn ? 'TOS.CLEAR_DATA.CONFIRM_LOGOUT' : 'TOS.CLEAR_DATA.CONFIRM';
    if (!window.confirm(this.translate.instant(confirmKey))) {
      return;
    }

    this.isClearing = true;
    try {
      await this.authService.clearLocalDataAndLogout();
    } finally {
      this.isClearing = false;
    }
  }
}
